import mitt from "mitt";
import { PopupBusEvents } from "@/common/buses/popups/types";
export const bus = mitt<PopupBusEvents>();
